import api from './api';
import {
  BillingPlansResponse,
  ChangePlanResponse,
  CheckoutResponse,
  CreateTrialCheckoutPayload,
  SubscriptionStatus,
} from '../types';

export const subscriptionService = {
  getStatus: async (): Promise<SubscriptionStatus> => {
    const response = await api.get<SubscriptionStatus>('/api/subscription/status');
    return response.data;
  },

  getPlans: async (): Promise<BillingPlansResponse> => {
    // Public endpoint; auth still gets attached by the interceptor when
    // available, but the server treats it as anonymous-safe.
    const response = await api.get<BillingPlansResponse>('/api/subscription/plans');
    return response.data;
  },

  createTrialCheckout: async (
    payload: CreateTrialCheckoutPayload = {},
  ): Promise<CheckoutResponse> => {
    const response = await api.post<CheckoutResponse>(
      '/api/subscription/create-trial-checkout',
      payload,
    );
    return response.data;
  },

  // Change an EXISTING subscription's cadence/plan in place (no new checkout).
  changePlan: async (
    payload: CreateTrialCheckoutPayload = {},
  ): Promise<ChangePlanResponse> => {
    const response = await api.post<ChangePlanResponse>(
      '/api/subscription/change-plan',
      payload,
    );
    return response.data;
  },

  validateLicense: async () => {
    const response = await api.get('/api/license/validate');
    return response.data;
  },
};
